angular.module('admin.articles.detail', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'directives.serverError',
  'ui.bootstrap',
  'ui.bootstrap.dropdown'
]);

// angular.module('admin.articles.detail').config(function($stateProvider) {
//   $stateProvider
//     .state('admin.articles.detail', {
//       url: '/:id',
//       title: 'Article / Details',
//       views: {
//         'main@': {
//           template: require('./article.tpl.html'),
//           controller: 'ArticleDetailCtrl',
//           resolve: {
//             article: function(adminResource, $stateParams) {
//               return adminResource.findArticle($stateParams.id);
//             },
//             categories: function(adminResource) {
//               var options = [];
//
//               var generateCategoryOptions = function(items, container) {
//                 items.forEach(function(item) {
//                   if (!item.path) {
//                     return;
//                   }
//
//                   //console.log(item);
//                   var depth = item.path.split('/').filter(Boolean).length;
//                   var indent = (new Array(7)).join(String.fromCharCode(160));
//
//                   container.push({
//                     _id: item._id,
//                     path: item.path,
//                     name: (new Array(depth)).join(indent) + item.name
//                   });
//
//                   if (item.children) {
//                     generateCategoryOptions(item.children, container);
//                   }
//                 });
//
//                 return container;
//               };
//
//               return adminResource.getMenusTree().then(function(data) {
//                 generateCategoryOptions(data, options);
//                 return options;
//               });
//             }
//           }
//         }
//       }
//     });
// });
//
// angular.module('admin.articles.detail').controller('ArticleDetailCtrl', [
//   '$scope',
//   '$route',
//   '$location',
//   '$log',
//   'utility',
//   'adminResource',
//   'article',
//   'categories',
//   'STATUSES',
//   'ARTICLE_STYLES',
//   function($scope, $route, $location, $log, utility, adminResource, data, categories, STATUSES, ARTICLE_STYLES) {
//     $scope.statuses = STATUSES;
//     $scope.categories = categories;
//     $scope.article_styles = ARTICLE_STYLES;
//
//     $scope.accordion = {
//       status: true,
//       category: true,
//       article_style: true,
//       author: true
//     };
//
//     // local vars
//     var deserializeData = function(data){
//       //$scope.statuses = data.statuses;
//       deserializeAccountGroup(data.record || data);
//     };
//     var deserializeAccountGroup = function (data){
//       var path = '/' + _.map(data.categories, 'sefriendly').reverse().join('/');
//       $scope.article = data;
//       $scope.article.status = _.find(STATUSES, {id: data.status + ''});
//       $scope.article.category = _.find($scope.categories, {path: path});
//       $scope.article.show_inarticle = _.find(ARTICLE_STYLES, {id: data.show_inarticle + ''});
//     };
//     var closeAlert = function(alert, ind){
//       alert.splice(ind, 1);
//     };
//     var isExistingPermission = function(newPermission){
//       var flag = false;
//       angular.forEach($scope.group.permissions, function(permission, ind){
//         if(permission.name === newPermission){
//           flag = true;
//         }
//       });
//       return flag;
//     };
//     //$scope vars
//     $scope.ckOptions = {
//       skin: 'moono',
//       extraPlugins: 'justify,autogrow',
//       autoGrow_minHeight: 250
//     };
//     $scope.detailAlerts = [];
//     $scope.deleteAlerts = [];
//     $scope.statusAlerts = [];
//     $scope.permissionAlerts = [];
//     $scope.categoryAlerts = [];
//     $scope.canSave = utility.canSave;
//     $scope.hasError = utility.hasError;
//     $scope.showError = utility.showError;
//     $scope.closeDetailAlert = function(ind){
//       closeAlert($scope.detailAlerts, ind);
//     };
//     $scope.closeDeleteAlert = function(ind){
//       closeAlert($scope.deleteAlerts, ind);
//     };
//     $scope.closePermissionAlert = function(ind){
//       closeAlert($scope.permissionAlerts, ind);
//     };
//     $scope.update = function(){
//       $scope.detailAlerts = [];
//       adminResource.updateAccountGroup($scope.group._id, { name: $scope.group.name }).then(function(result){
//         if(result.success){
//           deserializeAccountGroup(result.AccountGroup);
//           $scope.detailAlerts.push({ type: 'info', msg: 'Changes have been saved.'});
//         }else{
//           angular.forEach(result.errors, function(err, index){
//             $scope.detailAlerts.push({ type: 'danger', msg: err });
//           });
//         }
//       }, function(x){
//         $scope.detailAlerts.push({ type: 'danger', msg: 'Error updating admin group: ' + x });
//       });
//     };
//     $scope.addPermission = function(){
//       if(!$scope.newPermission){
//         alert('Please enter a name.');
//       } else if(isExistingPermission($scope.newPermission)){
//         alert('That name already exists.');
//       }else{
//         $scope.group.permissions.push({
//           name: angular.copy($scope.newPermission),
//           permit: true
//         });
//       }
//       $scope.newPermission = null;  //reset newPermission after user interaction
//     };
//     $scope.togglePermission = function(index){
//       $scope.group.permissions[index]['permit'] = !$scope.group.permissions[index]['permit'];
//     };
//     $scope.deletePermission = function(index){
//       if(confirm('Are you sure?')){
//         $scope.group.permissions.splice(index, 1);
//       }
//     };
//     $scope.saveSettings = function(){
//       $scope.permissionAlerts = [];
//       var permissions = $scope.group.permissions;
//       adminResource.saveAccountGroupPermissions($scope.group._id, {permissions: permissions}).then(function (result) {
//         if (result.success) {
//           $scope.permissionAlerts.push({type: 'info', msg: 'Changes have been saved.'});
//           deserializeAccountGroup(result.AccountGroup);
//         } else {
//           //error due to server side validation
//           angular.forEach(result.errors, function (err, index) {
//             $scope.permissionAlerts.push({type: 'danger', msg: err});
//           });
//         }
//       }, function (x) {
//         $scope.permissionAlerts.push({type: 'danger', msg: 'Error saving admin group permissions: ' + x});
//       });
//     };
//     $scope.changeStatus = function(){
//       $scope.statusAlerts = [];
//       if($scope.selectedStatus && $scope.selectedStatus._id){
//         if($scope.selectedStatus._id === $scope.group.status.id){
//           // status selected is the current status
//           $scope.statusAlerts.push({ type: 'danger', msg: 'That is the current status.'});
//         }else{
//           // update status
//           var data = {
//             id: $scope.selectedStatus._id,
//             name: $scope.selectedStatus.name
//           };
//           adminResource.newAccountGroupStatus($scope.group._id, data).then(function(result){
//             if(result.success){
//               deserializeAccountGroup(result.AccountGroup);
//             }else{
//               //error due to server side validation
//               angular.forEach(result.errors, function(err, index){
//                 $scope.statusAlerts.push({ type: 'danger', msg: err});
//               });
//             }
//           }, function(x){
//             $scope.statusAlerts.push({ type: 'danger', msg: 'Error adding new status: ' + x});
//           });
//         }
//       }else{ //no status is selected
//         $scope.statusAlerts.push({ type: 'danger', msg: 'Please choose a status.'});
//       }
//     };
//     $scope.deleteAccountGroup = function(){
//       $scope.deleteAlerts =[];
//       if(confirm('Are you sure?')){
//         adminResource.deleteAccountGroup($scope.group._id).then(function(result){
//           if(result.success){
//             //redirect to admin account-groups index page
//             $location.path('/admin/account-groups');
//           }else{
//             //error due to server side validation
//             angular.forEach(result.errors, function(err, index){
//               $scope.deleteAlerts.push({ type: 'danger', msg: err});
//             });
//           }
//         }, function(x){
//           $scope.deleteAlerts.push({ type: 'danger', msg: 'Error deleting admin group: ' + x });
//         });
//       }
//     };
//
//
//     $scope.statusModel = [];
//     $scope.statusData = STATUSES;
//     $scope.selectSettings = {
//       closeList: false
//     };
//     $scope.saveStatus = function() {
//       adminResource.saveAccountGroupStatus($scope.group._id, $scope.statusModel).then(function (result) {
//         if(result.success){
//           //deserializeAccountGroup(result.AccountGroup);
//           $scope.statusAlerts.push({type: 'info', msg: 'Changes have been saved.'});
//         }else{
//           //error due to server side validation
//           angular.forEach(result.errors, function(err, index){
//             $scope.statusAlerts.push({ type: 'danger', msg: err});
//           });
//         }
//       }, function(x){
//         $scope.statusAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
//       });
//     };
//
//     $scope.toggleNode = function(node) {
//       var modelValue = node.$nodeScope.$modelValue;
//       adminResource.findCategoriesByPath(modelValue.path).then(function(result) {
//         node.$nodeScope.$modelValue.children = result.data;
//         node.toggle();
//       });
//     };
//
//     $scope.toggleCategorySelection = function(id) {
//       var idx = $scope.group.categories.indexOf(id);
//       if (idx > -1) {
//         $scope.group.categories.splice(idx, 1);
//       }
//       else {
//         $scope.group.categories.push(id);
//       }
//     };
//
//     $scope.saveCategories = function() {
//       adminResource.saveAccountGroupCategories($scope.group._id, $scope.group.categories).then(function (result) {
//         if(result.success){
//           $scope.categoryAlerts.push({type: 'info', msg: 'Changes have been saved.'});
//         }else{
//           //error due to server side validation
//           angular.forEach(result.errors, function(err, index){
//             $scope.categoryAlerts.push({ type: 'danger', msg: err});
//           });
//         }
//       }, function(x){
//         $scope.categoryAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
//       });
//     };
//
//     //initialize
//     deserializeData(data);
//   }
// ]);



// WEBPACK FOOTER //
// ./client/src/app/admin/articles/article.js